/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import Test from '../views/test.vue';

export const route = [
  {
    path: '/test/test',
    component: Test,
    meta: {
      title: '测试'
    }
  }
];
